import { Skeleton } from "antd";
import { useEffect, useRef, useState } from "react";

const PDFPreview = ({ file, fromComment }: { file: any, fromComment: boolean }) => {

    const ref = useRef<HTMLDivElement | null>(null);
    const [isVisible, setIsVisible] = useState(false);
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const [pdfUrl, setPdfUrl] = useState<string>("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect(); // only load once
                }
            },
            { threshold: 0.25 } // 25% visible
        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            observer.disconnect();
        };
    }, []);

    useEffect(() => {
        if (isVisible && file?.url) {
            setLoading(true);
            let pdfLink = file.url;
            if (pdfLink.startsWith("http://")) {
                const fileLink = pdfLink.replace("http://", "https://");
                setPdfUrl(fileLink);
                setLoading(false);
            }
            else {
                setPdfUrl(pdfLink);
                setLoading(false);
            }

        }
    }, [isVisible, file]);

    return (
        <div ref={ref} style={{ marginBottom: "20px" }}>
            {loading && (
                <div style={{ textAlign: "center", padding: "20px" }}>
                    <Skeleton active paragraph={{ rows: 5 }} />
                </div>
            )}
            {!loading && pdfUrl && (
                <iframe
                    ref={iframeRef}
                    src={pdfUrl}
                    width="100%"
                    height={fromComment ? "450px" : "300px"}
                    title={file.fileName || "PDF Preview"}
                    style={{ border: "none", width: "100%" }}
                />
            )}
        </div>
    );
};


export default PDFPreview;


/* import { Skeleton } from "antd";
import { useEffect, useRef, useState } from "react";

const PDFPreview = ({ file, fromComment }: { file: any; fromComment: boolean }) => {
    const ref = useRef<HTMLDivElement | null>(null);
    const [isVisible, setIsVisible] = useState(false);
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const [pdfUrl, setPdfUrl] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.25 }
        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            observer.disconnect();
        };
    }, []);

    useEffect(() => {
        if (isVisible && file?.url) {
            setLoading(true);
            let pdfLink = file.url;
            if (pdfLink.startsWith("http://")) {
                pdfLink = pdfLink.replace("http://", "https://");
            }

            fetch(pdfLink, { cache: "force-cache" })
                .then((res) => res.blob())
                .then((blob) => {
                    const blobUrl = URL.createObjectURL(blob);
                    setPdfUrl(blobUrl);
                })
                .finally(() => setLoading(false))
                .catch((err) => console.error("Failed to fetch PDF:", err));
        }
    }, [isVisible, file]);


    return (
        <div ref={ref} style={{ marginBottom: "20px", position: "relative" }}>
            {loading && (
                <div style={{ textAlign: "center", padding: "20px" }}>
                    <Skeleton active paragraph={{ rows: 5 }} />
                </div>
            )}
            {!loading && pdfUrl && (
                <iframe
                    ref={iframeRef}
                    src={pdfUrl}
                    width="100%"
                    height={fromComment ? "450px" : "300px"}
                    title={file.fileName || "PDF Preview"}
                    style={{ border: "none" }}
                />
            )}
        </div>
    );
};

export default PDFPreview;
 */